var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorativeBgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 110,
    viewBox: "0 0 449 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.166,
    y: 87.1112,
    width: 23.8236,
    height: 23.8236,
    rx: 11.9118,
    transform: "rotate(162.106 259.166 87.1112)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.3,
    y: 110.613,
    width: 223.462,
    height: 23.8236,
    rx: 11.9118,
    transform: "rotate(162.106 346.3 110.613)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.561,
    y: 102.992,
    width: 195.056,
    height: 23.8236,
    rx: 11.9118,
    transform: "rotate(162.106 208.561 102.992)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.027,
    y: 28.6757,
    width: 102.497,
    height: 23.8236,
    rx: 11.9118,
    transform: "rotate(162.106 434.027 28.6757)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.159,
    y: 52.8495,
    width: 87.6884,
    height: 23.8236,
    rx: 11.9118,
    transform: "rotate(162.106 359.159 52.8495)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.159,
    y: 52.8495,
    width: 23.8236,
    height: 23.8236,
    rx: 11.9118,
    transform: "rotate(162.106 359.159 52.8495)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.069,
    y: 27.7733,
    width: 159.056,
    height: 23.8236,
    rx: 11.9118,
    transform: "rotate(162.106 276.069 27.7733)",
    fill: "#435E64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeBgSvg1);
export default __webpack_public_path__ + "static/media/decorative-bg-svg1.c9116d982e2683e59a23017f6cf8f73d.svg";
export { ForwardRef as ReactComponent };